// import StudentResults from "../../../../dummy_data/StudentResult.json";
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { useState } from "react";
import TermBroadsheet from "../component/TermBroadsheet";
import SessionBroadsheet from "../component/SessionBroadsheet";
// import { CardSearch } from "../../../../components/CardSearch";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const BroadSheet = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout children={
      <>
        <PageTitle
          title="Academic Broadsheet"
          subtitle="See the breakdown of students results."
          // button={
          //   <div>
          //     <Button
          //       variant="primary"
          //       buttonSize="fluid"
          //       color="btndefault"
          //       // onClick={() => handleCreateNoteModal()}
          //       buttonName="Add Result to Broadsheet"
          //     />
          //   </div>
          // }
        />

        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
              <Tab label="Session Broadsheet" value="1" />
              <Tab label="Term Broadsheet" value="2" />
            </Tabs>
          </div>
          <div>
            <TabPanel value="1" className="tabpanel-overide no_padding_0">
              <SessionBroadsheet />
            </TabPanel>
            <TabPanel value="2" className="tabpanel-overide no_padding_0">
              <TermBroadsheet />
            </TabPanel>
            {/* <TabPanel value="3" className="tabpanel-overide"><Apikeys /></TabPanel> */}
          </div>
        </TabContext>
      </>
    }
    />
  );
};

export default BroadSheet;
